import { BusEvent } from '@web/common';

export class WarehouseRestockCreatedBusEvent extends BusEvent {}
